import React, { useState, useEffect } from 'react';
import apiService from '../services/apiService';
import { Bot, Edit3, Trash2, CheckCircle, Search, Filter, Plus, Users, MessageSquare, Send, Bell, Award, Zap, Check, Activity, Camera, Sparkles, Image as ImageIcon } from 'lucide-react';
import './AiStaffPage.css';

const getDepartment = (role) => {
    const r = (role || "").toLowerCase();
    if (r.includes('voice') || r.includes('chat') || r.includes('reception')) return "Front Desk";
    if (r.includes('seo') || r.includes('marketing') || r.includes('content')) return "Marketing";
    if (r.includes('legal') || r.includes('probate') || r.includes('medicaid')) return "Legal";
    return "Operations";
};

const ImageBubble = ({ src, alt, onSetAvatar, onDeletePhoto }) => {
    const [lightbox, setLightbox] = useState(false);
    const [savingAvatar, setSavingAvatar] = useState(false);
    const [avatarDone, setAvatarDone] = useState(false);
    const fullUrl = src.startsWith('/api/') ? `${window.location.origin}${src}` : src;

    const handleAvatarClick = async (e) => {
        e.stopPropagation();
        if (!onSetAvatar || savingAvatar) return;
        setSavingAvatar(true);
        try {
            await onSetAvatar(src);
            setAvatarDone(true);
            setTimeout(() => setAvatarDone(false), 3000);
        } catch (e) {
            console.error('Avatar update failed', e);
            alert('Не удалось обновить аватар: ' + (e.message || 'Ошибка'));
        } finally {
            setSavingAvatar(false);
        }
    };

    const handleDeleteClick = async (e) => {
        e.stopPropagation();
        if (onDeletePhoto) {
            await onDeletePhoto(src);
            setLightbox(false);
        }
    };

    return (
        <>
            <div className="generated-image-wrap" style={{ marginTop: '0.5rem', marginBottom: '0.25rem' }}>
                <img
                    src={src}
                    alt={alt || 'Generated'}
                    style={{ maxWidth: '100%', maxHeight: '340px', borderRadius: '10px', cursor: 'zoom-in', display: 'block', objectFit: 'cover' }}
                    onClick={() => setLightbox(true)}
                />
                <div style={{ display: 'flex', gap: '6px', marginTop: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <button type="button" onClick={() => setLightbox(true)} style={{ fontSize: '11px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '6px', color: '#ccc', cursor: 'pointer', padding: '3px 8px', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>🔍 Увеличить</button>
                    <a href={fullUrl} download target="_blank" rel="noreferrer" style={{ fontSize: '11px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '6px', color: '#ccc', cursor: 'pointer', padding: '3px 8px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>⬇ Скачать</a>
                    {onSetAvatar && (
                        <button
                            type="button"
                            onClick={handleAvatarClick}
                            disabled={savingAvatar}
                            style={{
                                fontSize: '11px',
                                background: avatarDone ? '#1b4332' : '#2a2415',
                                border: `1px solid ${avatarDone ? '#52b788' : '#C8A653'}`,
                                borderRadius: '6px',
                                color: avatarDone ? '#b7e4c7' : '#f4d58d',
                                cursor: 'pointer',
                                padding: '3px 10px',
                                fontWeight: 600,
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            {savingAvatar ? '⏳...' : avatarDone ? '✓ На аватаре' : '👤 На аватар'}
                        </button>
                    )}
                    {onDeletePhoto && (
                        <button
                            type="button"
                            onClick={handleDeleteClick}
                            style={{
                                fontSize: '11px',
                                background: 'rgba(239, 68, 68, 0.12)',
                                border: '1px solid rgba(239, 68, 68, 0.3)',
                                borderRadius: '6px',
                                color: '#fca5a5',
                                cursor: 'pointer',
                                padding: '3px 8px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                transition: 'all 0.2s ease'
                            }}
                            title="Удалить фото"
                        >
                            <Trash2 size={11} /> Удалить
                        </button>
                    )}
                </div>
            </div>
            {lightbox && (
                <div onClick={() => setLightbox(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out', padding: '20px' }}>
                    <img src={src} alt={alt || 'Generated'} style={{ maxWidth: '90vw', maxHeight: '82vh', borderRadius: '8px', objectFit: 'contain' }} onClick={e => e.stopPropagation()} />
                    <div style={{ display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap', justifyContent: 'center' }} onClick={e => e.stopPropagation()}>
                        {onSetAvatar && (
                            <button
                                type="button"
                                onClick={handleAvatarClick}
                                disabled={savingAvatar}
                                style={{
                                    background: avatarDone ? '#1b4332' : '#2a2415',
                                    border: `1px solid ${avatarDone ? '#52b788' : '#C8A653'}`,
                                    color: avatarDone ? '#b7e4c7' : '#f4d58d',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    fontSize: '13px'
                                }}
                            >
                                {savingAvatar ? '⏳ Обновление...' : avatarDone ? '✓ Аватар обновлен!' : '👤 Сделать моим аватаром'}
                            </button>
                        )}
                        <a href={fullUrl} download target="_blank" rel="noreferrer" style={{ background: '#333', color: '#fff', padding: '8px 16px', borderRadius: '6px', textDecoration: 'none', fontSize: '13px', display: 'flex', alignItems: 'center' }}>⬇ Скачать оригинал</a>
                        {onDeletePhoto && (
                            <button
                                type="button"
                                onClick={handleDeleteClick}
                                style={{
                                    background: '#dc2626',
                                    color: '#fff',
                                    border: 'none',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontSize: '13px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                            >
                                <Trash2 size={14} /> Удалить фото
                            </button>
                        )}
                        <button type="button" onClick={() => setLightbox(false)} style={{ background: 'rgba(255,255,255,0.1)', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>✕ Закрыть</button>
                    </div>
                </div>
            )}
        </>
    );
};

const renderSocialContent = (text, onSetAvatar, onDeletePhoto) => {
    if (!text) return null;
    // Parse both markdown images ![alt](url) and [IMAGE: url] tags
    const parts = text.split(/(!\[.*?\]\([^)]+\)|\[IMAGE:\s*[^\]]+\])/g);
    return parts.map((part, index) => {
        // Markdown image: ![alt](url)
        const mdMatch = part.match(/^!\[(.*?)\]\(([^)]+)\)$/);
        if (mdMatch) {
            return <ImageBubble key={index} src={mdMatch[2]} alt={mdMatch[1]} onSetAvatar={onSetAvatar} onDeletePhoto={onDeletePhoto} />;
        }
        // [IMAGE: url] tag
        const tagMatch = part.match(/^\[IMAGE:\s*([^\]]+)\]$/);
        if (tagMatch) {
            return <ImageBubble key={index} src={tagMatch[1].trim()} alt="Generated" onSetAvatar={onSetAvatar} onDeletePhoto={onDeletePhoto} />;
        }
        // Plain text — preserve whitespace/newlines
        return <span key={index} style={{ whiteSpace: 'pre-wrap' }}>{part}</span>;
    });
};

const RoomPanel = ({ name, span, occupants, openProfile, color, icon, onDropAgent }) => {
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = `2px dashed ${color}`;
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = `1px solid ${color}40`;
        e.currentTarget.style.borderTop = `4px solid ${color}`;
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.currentTarget.style.border = `1px solid ${color}40`;
        e.currentTarget.style.borderTop = `4px solid ${color}`;
        const agentId = e.dataTransfer.getData('text/plain');
        if (agentId && onDropAgent) {
            onDropAgent(agentId, name);
        }
    };

    return (
        <div 
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop} style={{ 
            gridColumn: `span ${span}`, 
            background: 'hsl(var(--card))', 
            borderRadius: '16px', 
            border: '1px solid hsl(var(--border))',
            borderTop: '3px solid hsl(var(--primary))',
            boxShadow: '0 1px 3px rgba(32, 35, 31, 0.04)',
            padding: '16px 18px',
            minHeight: '150px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <h4 style={{ margin: '0 0 15px 0', color: 'hsl(var(--foreground))', fontSize: '13px', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '8px', fontFamily: 'Georgia, serif' }}>
                <span style={{ fontSize: '16px' }}>{icon}</span> {name}
                <span style={{ marginLeft: 'auto', fontSize: '11px', fontWeight: '600', background: 'hsl(var(--accent))', color: 'var(--ais-gold-ink)', border: '1px solid hsl(var(--primary) / 0.35)', padding: '2px 8px', borderRadius: '10px' }}>
                    {occupants ? occupants.length : 0}
                </span>
            </h4>
            
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {occupants && occupants.map((occ, idx) => {
                    const isInteracting = occ.status === "Interacting";
                    return (
                        <div key={idx} 
                             draggable
                             onDragStart={(e) => {
                                 e.dataTransfer.setData('text/plain', occ.agent.id);
                             }}
                             onClick={() => openProfile(occ.agent)}
                             style={{ 
                                display: 'flex', flexDirection: 'column', alignItems: 'center', 
                                cursor: 'pointer',
                                background: isInteracting ? 'hsl(var(--accent))' : 'hsl(var(--background))',
                                border: `1px solid ${isInteracting ? 'hsl(var(--primary))' : 'hsl(var(--border))'}`,
                                padding: '8px 6px', borderRadius: '12px', width: '64px',
                                transition: 'all 0.2s',
                                boxShadow: '0 1px 2px rgba(32, 35, 31, 0.05)'
                             }}
                             className="hover:scale-105 transition-transform"
                             title={`${occ.agent.name} - ${occ.agent.role} (${occ.status})`}
                        >
                            <div style={{ position: 'relative' }}>
                                <img 
                                    src={occ.agent.avatar_url || '/api/v1/uploads/katifi-avatar.png'} 
                                    alt={occ.agent.name} 
                                    style={{ width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover', border: '1px solid hsl(var(--border))' }} 
                                />
                                <div style={{ 
                                    position: 'absolute', bottom: '-1px', right: '-1px', 
                                    width: '11px', height: '11px', borderRadius: '50%', 
                                    background: isInteracting ? 'hsl(var(--primary))' : 'var(--ais-green)',
                                    border: '2px solid hsl(var(--card))' 
                                }}></div>
                            </div>
                            <span style={{ fontSize: '11px', fontWeight: '600', color: 'hsl(var(--foreground))', marginTop: '5px', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                                {occ.agent.name.split(' ')[0]}
                            </span>
                            <span style={{ fontSize: '9px', color: isInteracting ? 'var(--ais-gold-ink)' : 'var(--ais-muted-ink)', textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                                {isInteracting ? 'Active' : 'Working'}
                            </span>
                        </div>
                    );
                })}
            </div>
            {(!occupants || occupants.length === 0) && (
                <div style={{ margin: 'auto', color: 'var(--ais-muted-ink)', fontSize: '12px', fontStyle: 'italic' }}>Empty</div>
            )}
        </div>
    );
};

const AiStaffPage = () => {
    // Navigation & State
    const [activeView, setActiveView] = useState('office'); // 'office', 'profile', 'group_chat', 'tasks'
    const [locations, setLocations] = useState({});
    const [loading, setLoading] = useState(true);

    // Photo Library State
    const [photoLibrary, setPhotoLibrary] = useState([]);
    const [photoFilter, setPhotoFilter] = useState('all');
    const [photoLoading, setPhotoLoading] = useState(false);
    
    // Katifi Engine State
    const [socialGroups, setSocialGroups] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [isNotifOpen, setNotifOpen] = useState(false);
    const [taskBoard, setTaskBoard] = useState([]);
    
    // Directory Filters
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('name');
    
    // Profile State
    const [currentAgent, setCurrentAgent] = useState(null);
    const [agentPosts, setAgentPosts] = useState([]);
    const [agentGroups, setAgentGroups] = useState([]);
    const [agentDms, setAgentDms] = useState([]);
    const [dmInput, setDmInput] = useState('');
    const [dmLoading, setDmLoading] = useState(false);
    const [profileTab, setProfileTab] = useState('dms');
    const [agentMemories, setAgentMemories] = useState([]);
    const [agentSkills, setAgentSkills] = useState([]);
    const [newMemoryText, setNewMemoryText] = useState('');
    const [newMemoryType, setNewMemoryType] = useState('creator_preference');
    const [isAddingMemory, setIsAddingMemory] = useState(false); // Default to DMs!

    // DM Attachment State
    const [dmAttachmentBase64, setDmAttachmentBase64] = useState(null);
    const [dmAttachmentMime, setDmAttachmentMime] = useState(null);
    const [dmAttachmentPreview, setDmAttachmentPreview] = useState(null);
    const fileInputRef = React.useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);
        setDmAttachmentPreview(previewUrl);
        setDmAttachmentMime(file.type);

        const reader = new FileReader();
        reader.onloadend = () => {
            setDmAttachmentBase64(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const clearAttachment = () => {
        setDmAttachmentBase64(null);
        setDmAttachmentMime(null);
        setDmAttachmentPreview(null);
        if (fileInputRef.current) fileInputRef.current.value = "";
    };

    // Group state
    const [currentGroup, setCurrentGroup] = useState(null);
    const [groupMessages, setGroupMessages] = useState([]);
    const [groupInput, setGroupInput] = useState('');
    
    // Tasks Form
    const [newTaskModalOpen, setNewTaskModalOpen] = useState(false);
    const [newTaskTitle, setNewTaskTitle] = useState('');
    const [newTaskDesc, setNewTaskDesc] = useState('');

    const handleDropAgent = async (agentId, newLocationName) => {
        setLocations(prev => {
            const updated = { ...prev };
            let foundAgent = null;
            
            // Remove agent from old location
            for (const loc in updated) {
                if (updated[loc]) {
                    const idx = updated[loc].findIndex(o => o.agent.id === agentId);
                    if (idx !== -1) {
                        foundAgent = updated[loc][idx];
                        updated[loc] = updated[loc].filter(o => o.agent.id !== agentId);
                    }
                }
            }
            
            if (foundAgent) {
                foundAgent.location = newLocationName;
                if (!updated[newLocationName]) updated[newLocationName] = [];
                updated[newLocationName].push(foundAgent);
            }
            return updated;
        });

        try {
            await apiService.updateAgentLocation(agentId, newLocationName);
        } catch (err) {
            console.error("Failed to save new location", err);
            fetchData(); // Rollback
        }
    };

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 10000); // Polling every 10 seconds to update interactions
        return () => clearInterval(interval);
    }, []);

    const fetchData = async () => {
        try {
            const [grp, notif, tsk, locs] = await Promise.all([
                apiService.getSocialGroups(),
                apiService.getOmniscienceNotifications(),
                apiService.getTaskBoard(),
                apiService.makeRequest('/admin/agents/office_locations')
            ]);
            
            setLocations(locs || {});
            setSocialGroups(grp || []);
            setNotifications(notif || []);
            setTaskBoard(tsk || []);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const openProfile = async (agent) => {
        setCurrentAgent(agent);
        setActiveView('profile');
        setProfileTab('dms'); // Always default to chat!
        
        try {
            const [posts, ags, dms, mems, sks] = await Promise.all([
                apiService.getAgentPosts(agent.id),
                apiService.getAgentSocialGroups(agent.id),
                apiService.getAgentDMs(agent.id),
                apiService.getAgentMemories(agent.id).catch(() => []),
                apiService.getAgentSkills(agent.id).catch(() => [])
            ]);
            setAgentPosts(posts || []);
            setAgentGroups(ags || []);
            setAgentDms(dms || []);
            setAgentMemories(mems || []);
            setAgentSkills(sks || []);
        } catch (err) {
            console.error("Failed to load agent social history", err);
        }
    };

    const handleSetAvatar = async (imageUrl) => {
        if (!currentAgent?.id) return;
        try {
            await apiService.updateAgentProfile(currentAgent.id, { avatar_url: imageUrl });
            setCurrentAgent(prev => prev ? { ...prev, avatar_url: imageUrl } : prev);
            setLocations(prev => {
                const updated = { ...prev };
                for (const loc in updated) {
                    if (updated[loc]) {
                        updated[loc] = updated[loc].map(occ => {
                            if (occ.agent && occ.agent.id === currentAgent.id) {
                                return { ...occ, agent: { ...occ.agent, avatar_url: imageUrl } };
                            }
                            return occ;
                        });
                    }
                }
                return updated;
            });
        } catch (err) {
            console.error('Failed to set avatar:', err);
            throw err;
        }
    };

    const handleRequestSelfie = async (contextHint = "в офисе") => {
        if (!currentAgent || dmLoading) return;
        
        const userMsg = {
            id: 'temp-u-' + Date.now(),
            content: `📸 Сделай свое фото (${contextHint})`,
            created_at: new Date().toISOString(),
            is_from_agent: false
        };
        setAgentDms(prev => [...prev, userMsg]);
        setDmLoading(true);
        
        try {
            const res = await apiService.postAgentSelfie(currentAgent.id, contextHint);
            if (res?.reply) {
                setAgentDms(prev => [...prev, res.reply]);
            } else if (res?.image_url) {
                setAgentDms(prev => [...prev, {
                    id: 'selfie-' + Date.now(),
                    content: `Вот мое свежее фото для вас! 📸\n\n[IMAGE: ${res.image_url}]`,
                    created_at: new Date().toISOString(),
                    is_from_agent: true
                }]);
            }
        } catch (err) {
            console.error("Selfie generation error:", err);
            setAgentDms(prev => [...prev, {
                id: 'err-' + Date.now(),
                content: `⚠️ Не удалось сгенерировать фото: ${err.message || 'Ошибка генерации'}`,
                created_at: new Date().toISOString(),
                is_from_agent: true
            }]);
        } finally {
            setDmLoading(false);
        }
    };

    const handleQuickPrompt = (promptText) => {
        setDmInput(promptText);
    };

    const handleClearDMs = async () => {
        if (!currentAgent?.id) return;
        if (!window.confirm(`Вы уверены, что хотите полностью очистить переписку с ${currentAgent.name}? Это действие удалит все сообщения и созданные в чате фото.`)) return;
        try {
            await apiService.clearAgentDMs(currentAgent.id);
            setAgentDms([]);
        } catch (err) {
            console.error("Failed to clear DMs:", err);
            alert("Ошибка при очистке переписки: " + (typeof err === "string" ? err : (err?.message || JSON.stringify(err) || "Ошибка")));
        }
    };

    const handleAddMemory = async (e) => {
        e?.preventDefault();
        if (!currentAgent?.id || !newMemoryText.trim()) return;
        try {
            setIsAddingMemory(true);
            const created = await apiService.addAgentMemory(currentAgent.id, {
                content: newMemoryText.trim(),
                memory_type: newMemoryType,
                importance: 8
            });
            setAgentMemories(prev => [created, ...prev]);
            setNewMemoryText('');
            // update XP on agent
            setCurrentAgent(prev => ({ ...prev, compute_score: (prev.compute_score || 0) + 15 }));
        } catch (err) {
            console.error("Failed to add memory:", err);
            alert("Ошибка при сохранении воспоминания: " + (err.message || "Ошибка"));
        } finally {
            setIsAddingMemory(false);
        }
    };

    const handleDeleteMemoryItem = async (memoryId) => {
        if (!window.confirm("Удалить это воспоминание из постоянной памяти агента?")) return;
        try {
            await apiService.deleteAgentMemory(currentAgent.id, memoryId);
            setAgentMemories(prev => prev.filter(m => m.id !== memoryId));
        } catch (err) {
            console.error("Failed to delete memory:", err);
            alert("Ошибка при удалении воспоминания: " + (err.message || "Ошибка"));
        }
    };

    const handleDeleteMessage = async (msgId) => {
        if (!currentAgent?.id || !msgId) return;
        if (!window.confirm("Удалить это сообщение?")) return;
        try {
            await apiService.deleteAgentDM(currentAgent.id, msgId);
            setAgentDms(prev => prev.filter(m => m.id !== msgId));
        } catch (err) {
            console.error("Failed to delete message:", err);
            alert("Ошибка при удалении сообщения: " + (typeof err === "string" ? err : (err?.message || JSON.stringify(err) || "Ошибка")));
        }
    };

    const handleDeletePhotoFromChat = async (photoUrl, msgId) => {
        if (!window.confirm("Удалить эту фотографию из системы?")) return;
        try {
            await apiService.deletePhoto(photoUrl);
            if (msgId) {
                setAgentDms(prev => prev.map(m => {
                    if (m.id === msgId) {
                        const cleaned = (m.content || '')
                            .replace(new RegExp(`\[IMAGE:\s*${photoUrl}\]`, 'gi'), '')
                            .replace(new RegExp(`!\[.*?\]\(${photoUrl}\)`, 'gi'), '')
                            .trim();
                        return { ...m, content: cleaned || '*(Фото удалено)*' };
                    }
                    return m;
                }));
            }
            setPhotoLibrary(prev => prev.filter(p => p.url !== photoUrl));
        } catch (err) {
            console.error("Failed to delete photo:", err);
            alert("Ошибка при удалении фото: " + (typeof err === "string" ? err : (err?.message || JSON.stringify(err) || "Ошибка")));
        }
    };

    const handleDeleteGalleryPhoto = async (photo) => {
        if (!window.confirm("Удалить это фото из галереи?")) return;
        try {
            if (currentAgent?.id && photo.id) {
                await apiService.deleteAgentGalleryPhoto(currentAgent.id, photo.id);
            } else {
                await apiService.deletePhoto(photo.url || photo.id);
            }
            setPhotoLibrary(prev => prev.filter(p => p.id !== photo.id && p.url !== photo.url));
        } catch (err) {
            console.error("Failed to delete gallery photo:", err);
            alert("Ошибка при удалении фото: " + (typeof err === "string" ? err : (err?.message || JSON.stringify(err) || "Ошибка")));
        }
    };

    const loadPhotoLibrary = async (filter = 'agent') => {
        setPhotoLoading(true);
        setPhotoFilter(filter);
        try {
            if (filter === 'agent' && currentAgent?.id) {
                const res = await apiService.getAgentGallery(currentAgent.id);
                if (res?.gallery) {
                    setPhotoLibrary(res.gallery);
                    return;
                }
            }
            const personaParam = filter === 'agent' ? (currentAgent?.name?.toLowerCase() || 'all') : filter;
            const data = await apiService.makeRequest(`/admin/katifi/photos?persona=${personaParam}&limit=100`);
            setPhotoLibrary(data?.photos || []);
        } catch (e) {
            console.error('Photo library load error:', e);
        } finally {
            setPhotoLoading(false);
        }
    };

    const handleSendDM = async (e) => {
        e.preventDefault();
        if ((!dmInput.trim() && !dmAttachmentBase64) || !currentAgent) return;
        
        const contentVal = dmInput.trim() || '(Прислал фото для анализа)';
        
        const localMsg = {
            id: 'temp-' + Date.now(),
            content: contentVal,
            created_at: new Date().toISOString(),
            is_from_agent: false
        };
        setAgentDms(prev => [...prev, localMsg]);
        setDmInput('');
        
        const payloadBase64 = dmAttachmentBase64;
        const payloadMime = dmAttachmentMime;
        clearAttachment();
        
        if (currentAgent.id === "katifi-omniscient-id") {
            setDmLoading(true);
            setTimeout(() => {
                setAgentDms(prev => [...prev, {
                    id: 'temp-k-' + Date.now(),
                    content: "I am monitoring the entire AI Swarm. What global parameters do you wish to adjust, Director?",
                    created_at: new Date().toISOString(),
                    is_from_agent: true
                }]);
                setDmLoading(false);
            }, 1000);
            return;
        }

        setDmLoading(true);
        try {
            const payload = { content: localMsg.content };
            if (payloadBase64) {
                payload.image_base64 = payloadBase64;
                payload.mime_type = payloadMime;
            }
            const result = await apiService.postAgentDM(currentAgent.id, payload);
            // [FIX] Backend now returns reply directly — no polling delay needed
            if (result?.reply) {
                setAgentDms(prev => [...prev, result.reply]);
            } else {
                // Fallback: fetch after delay if reply not in response
                setTimeout(async () => {
                    const refreshed = await apiService.getAgentDMs(currentAgent.id);
                    setAgentDms(refreshed);
                }, 1000);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setDmLoading(false);
        }
    };
    
    const handleNewAgentPrompt = () => {
        alert("To create a new agent, switch to the 'Configuration > AI Swarm' settings panel, or ask Katifi.");
    };

    return (
        <div className="ai-staff-page">
            <div className="os-toolbar">
                <div className="toolbar-brand">
                    <BotsIcon />
                    <div>
                        <h1>Katifi Omniscience Engine</h1>
                        <p>Swarm Hierarchy & Collaboration Intranet</p>
                    </div>
                </div>
                
                <div className="toolbar-actions">
                    <button className={`nav-btn ${activeView==='office'?'active':''}`} onClick={()=>setActiveView('office')}>Virtual AI Office</button>
                    <button className={`nav-btn ${activeView==='tasks'?'active':''}`} onClick={()=>setActiveView('tasks')}>Task Board</button>
                    {currentGroup && <button className={`nav-btn ${activeView==='group_chat'?'active':''}`} onClick={()=>setActiveView('group_chat')}>Group Chat</button>}
                    {activeView === 'profile' && <button className="nav-btn active">Profile View</button>}
                    
                    <div className="bell-container" onClick={() => setNotifOpen(!isNotifOpen)}>
                        <Bell size={22} color="currentColor" style={{ color: 'var(--ais-muted-ink)' }}/>
                        {notifications.length > 0 && <span className="bell-badge">{notifications.length}</span>}
                        {isNotifOpen && (
                            <div className="bell-dropdown">
                                <h4>Katifi Alerts</h4>
                                {notifications.length === 0 ? <p className="text-muted">All systems normal.</p> : (
                                    notifications.map((n, i) => (
                                        <div className="notif-row" key={i}>
                                            <p>{n.message}</p>
                                        </div>
                                    ))
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="os-content-area">
                {activeView === 'office' && (
                    <div className="blueprint-view" style={{ padding: '20px', background: '#0f172a', minHeight: 'calc(100vh - 80px)', color: '#f8fafc' }}>
                        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h2 style={{ margin: 0, fontWeight: 300, fontSize: '28px', color: '#38bdf8' }}>AI Staff Facility</h2>
                                <p style={{ margin: '5px 0 0', color: '#94a3b8' }}>Real-time topological view of Swarm Activity</p>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', color: '#94a3b8' }}>
                                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></span> Idle / Working
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px', color: '#94a3b8' }}>
                                    <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#ef4444', animation: 'pulse 2s infinite' }}></span> Interacting
                                </div>
                            </div>
                        </div>

                        {loading ? (
                            <p style={{ textAlign: 'center', color: '#475569', padding: '100px' }}>Mapping facilities...</p>
                        ) : (
                            <div style={{ 
                                display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gridTemplateRows: 'auto', gap: '15px'
                            }}>
                                {/* Top Row: Front Desk, Meeting Room, Bar */}
                                <RoomPanel name="Front Desk" span="4" occupants={locations["Front Desk"]} openProfile={openProfile} color="#0284c7" icon="👋" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Meeting Room (Митинг рум)" span="5" occupants={locations["Meeting Room (Митинг рум)"]} openProfile={openProfile} color="#7c3aed" icon="📊" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Bar (Бар)" span="3" occupants={locations["Bar (Бар)"]} openProfile={openProfile} color="#be185d" icon="🍸" onDropAgent={handleDropAgent} />

                                {/* Middle Row: Ops, Legal, Marketing (The Big Departments) */}
                                <RoomPanel name="Operations Department" span="4" occupants={locations["Operations Department"]} openProfile={openProfile} color="#334155" icon="⚙️" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Legal Department" span="4" occupants={locations["Legal Department"]} openProfile={openProfile} color="#334155" icon="⚖️" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Marketing Department" span="4" occupants={locations["Marketing Department"]} openProfile={openProfile} color="#334155" icon="📈" onDropAgent={handleDropAgent} />
                                
                                {/* Bottom Row: Gym, Shower, Break Room, Cafeteria */}
                                <RoomPanel name="Gym (Спортзал)" span="3" occupants={locations["Gym (Спортзал)"]} openProfile={openProfile} color="#ea580c" icon="🏋️" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Shower (Душевая)" span="2" occupants={locations["Shower (Душевая)"]} openProfile={openProfile} color="#0d9488" icon="🚿" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Break Room (Комната отдыха)" span="3" occupants={locations["Break Room (Комната отдыха)"]} openProfile={openProfile} color="#ca8a04" icon="🛋️" onDropAgent={handleDropAgent} />
                                <RoomPanel name="Cafeteria (Кухня-столовая)" span="4" occupants={locations["Cafeteria (Кухня-столовая)"]} openProfile={openProfile} color="#16a34a" icon="☕" onDropAgent={handleDropAgent} />
                                
                                {/* Main Office Desks spillover */}
                                <RoomPanel name="Main Office Desks" span="12" occupants={locations["Main Office Desks"]} openProfile={openProfile} color="#475569" icon="💻" onDropAgent={handleDropAgent} />
                            </div>
                        )}
                    </div>
                )}

                {activeView === 'profile' && currentAgent && (
                    <div className="profile-view">
                        <div className="profile-sidebar">
                            <div className="profile-avatar-large">
                                {currentAgent.avatar_url ? <img src={currentAgent.avatar_url} alt="av"/> : <Bot size={64}/>}
                                {currentAgent.is_verified && <div className="large-badge"><Check/></div>}
                            </div>
                            <h2>{currentAgent.name}</h2>
                            <p className="agent-role">{currentAgent.specialized_role}</p>
                            <p className="agent-xp"><Award size={16}/> {currentAgent.compute_score || 0} XP earned</p>
                            <div className="profile-bio">
                                <strong>Persona:</strong>
                                <p>{currentAgent.persona}</p>
                            </div>
                            
                            <div className="profile-nav">
                                <button className={profileTab === 'dms' ? 'active' : ''} onClick={()=>setProfileTab('dms')}><MessageSquare size={16}/> Direct Chat</button>
                                <button className={profileTab === 'posts' ? 'active' : ''} onClick={()=>setProfileTab('posts')}>Public Posts</button>
                                <button className={profileTab === 'groups' ? 'active' : ''} onClick={()=>setProfileTab('groups')}>Strike Teams</button>
                                <button className={profileTab === 'photos' ? 'active' : ''} onClick={() => { setProfileTab('photos'); loadPhotoLibrary('agent'); }}>
                                    <Camera size={16}/> 📷 Фото & Галерея
                                </button>
                                <button className={profileTab === 'memory' ? 'active' : ''} onClick={()=>setProfileTab('memory')}>
                                    <Zap size={16}/> 🧠 Память ({agentMemories.length})
                                </button>
                                <button className={profileTab === 'skills' ? 'active' : ''} onClick={()=>setProfileTab('skills')}>
                                    <Award size={16}/> ⚡ Навыки & XP
                                </button>
                            </div>
                        </div>
                        
                        <div className="profile-main">
                            {profileTab === 'dms' && (
                                <div className="chat-interface">
                                    <div className="chat-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                        <div>
                                            <h3>Private Directives Channel</h3>
                                            <p>Send secure instructions directly to {currentAgent.name}. Interactions will permanently alter agent learning.</p>
                                        </div>
                                        {agentDms.length > 0 && (
                                            <button
                                                type="button"
                                                onClick={handleClearDMs}
                                                style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    fontSize: '12px',
                                                    padding: '5px 12px',
                                                    borderRadius: '8px',
                                                    border: '1px solid rgba(239, 68, 68, 0.4)',
                                                    background: 'rgba(239, 68, 68, 0.12)',
                                                    color: '#f87171',
                                                    cursor: 'pointer',
                                                    fontWeight: 600,
                                                    transition: 'all 0.2s ease'
                                                }}
                                                title="Удалить всю историю переписки"
                                            >
                                                <Trash2 size={13} /> Очистить переписку
                                            </button>
                                        )}
                                    </div>
                                    <div className="chat-history">
                                        {agentDms.length === 0 ? (
                                            <div className="chat-empty">Start the conversation with {currentAgent.name}...</div>
                                        ) : (
                                            agentDms.map(msg => (
                                                <div className={`chat-bubble-row ${msg.is_from_agent ? 'agent' : 'human'}`} key={msg.id}>
                                                    <div className="chat-bubble">
                                                        <button
                                                            type="button"
                                                            className="msg-delete-btn"
                                                            onClick={() => handleDeleteMessage(msg.id)}
                                                            title="Удалить это сообщение"
                                                        >
                                                            <Trash2 size={12} />
                                                        </button>
                                                        {renderSocialContent(
                                                            msg.content,
                                                            handleSetAvatar,
                                                            (photoUrl) => handleDeletePhotoFromChat(photoUrl, msg.id)
                                                        )}
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                        {dmLoading && <div className="chat-bubble-row agent"><div className="chat-bubble typing">Typing...</div></div>}
                                    </div>
                                    <div className="chat-scenario-chips" style={{ display: 'flex', gap: '6px', overflowX: 'auto', padding: '8px 12px', borderTop: '1px solid rgba(255,255,255,0.06)', background: 'rgba(0,0,0,0.25)', alignItems: 'center' }}>
                                        <span style={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap', marginRight: '4px' }}>⚡ Действия:</span>
                                        <button type="button" onClick={() => handleRequestSelfie("в офисе")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: '#2a2415', border: '1px solid #C8A653', color: '#f4d58d', cursor: 'pointer', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 600 }}>
                                            📸 Селфи
                                        </button>
                                        <button type="button" onClick={() => handleRequestSelfie("в зале переговоров")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#ddd', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            🏛️ В переговорной
                                        </button>
                                        <button type="button" onClick={() => handleRequestSelfie("за чашкой кофе в зоне отдыха")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#ddd', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            ☕ Кофе-тайм
                                        </button>
                                        <button type="button" onClick={() => handleQuickPrompt("Проведи экспресс-анализ текущих клиентских кейсов и задач")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#ddd', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            📊 Анализ кейса
                                        </button>
                                        <button type="button" onClick={() => handleQuickPrompt("Составь проект официального юридического ответа клиенту")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#ddd', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            ✉️ Деловое письмо
                                        </button>
                                        <button type="button" onClick={() => handleQuickPrompt("Проведи аудит документов и подготовь юридическую выжимку")} disabled={dmLoading} className="scenario-chip" style={{ fontSize: '12px', padding: '4px 10px', borderRadius: '14px', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.15)', color: '#ddd', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            💻 Аудит документов
                                        </button>
                                    </div>
                                    <form className="chat-input" onSubmit={handleSendDM} style={{ position: 'relative' }}>
                                        {dmAttachmentPreview && (
                                            <div style={{ position: 'absolute', bottom: '100%', left: '10px', marginBottom: '10px', padding: '6px', background: '#333', borderRadius: '8px', zIndex: 10, display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <img src={dmAttachmentPreview} alt="upload preview" style={{ height: '40px', borderRadius: '4px' }} />
                                                <button type="button" onClick={clearAttachment} style={{ background: 'red', color: 'white', border: 'none', borderRadius: '50%', width: '20px', height: '20px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>✕</button>
                                            </div>
                                        )}
                                        <div style={{ display: 'flex', width: '100%', gap: '8px', alignItems: 'center' }}>
                                            <input type="file" accept="image/*" ref={fileInputRef} onChange={handleFileChange} style={{ display: 'none' }} id="dm-file-upload"/>
                                            <label htmlFor="dm-file-upload" title="Прикрепить изображение" style={{ cursor: 'pointer', color: '#888', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
                                                📎
                                            </label>
                                            <button
                                                type="button"
                                                onClick={() => handleRequestSelfie("в офисе")}
                                                disabled={dmLoading}
                                                title="Сделать фото агента"
                                                style={{
                                                    background: '#2a2415',
                                                    border: '1px solid #C8A653',
                                                    borderRadius: '6px',
                                                    color: '#f4d58d',
                                                    cursor: 'pointer',
                                                    padding: '6px 10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 600,
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                📸 Селфи
                                            </button>
                                            <input type="text" placeholder={`Директива или вопрос для ${currentAgent.name}...`} value={dmInput} onChange={(e)=>setDmInput(e.target.value)} disabled={dmLoading} style={{ flex: 1 }} />
                                            <button type="submit" disabled={(!dmInput.trim() && !dmAttachmentBase64) || dmLoading}><Send size={16}/></button>
                                        </div>
                                    </form>
                                </div>
                            )}

                            {profileTab === 'posts' && (
                                <div className="post-feed">
                                    <h3>Autonomous Output</h3>
                                    {agentPosts.map(p => (
                                        <div className="feed-item" key={p.id}>
                                            <small>{new Date(p.created_at).toLocaleString()}</small>
                                            <p>{p.content}</p>
                                        </div>
                                    ))}
                                </div>
                            )}


                            {profileTab === 'memory' && (
                                <div style={{ padding: '1.25rem', maxWidth: '850px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem', flexWrap: 'wrap', gap: '8px' }}>
                                        <div>
                                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: 'hsl(var(--foreground))' }}>🧠 Постоянная память: {currentAgent.name}</h3>
                                            <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: 'var(--ais-muted-ink)' }}>
                                                Факты, привычки и предпочтения Директора, которые агент помнит сквозь любые сессии.
                                            </p>
                                        </div>
                                        <span style={{ background: 'hsl(var(--muted))', border: '1px solid hsl(var(--border))', color: 'var(--ais-muted-ink)', fontSize: '12px', fontWeight: 600, padding: '4px 12px', borderRadius: '16px' }}>
                                            {agentMemories.length} активных воспоминаний
                                        </span>
                                    </div>

                                    {/* Form to impart new memory directly */}
                                    <form onSubmit={handleAddMemory} style={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: '12px', padding: '14px', marginBottom: '1.5rem' }}>
                                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, color: 'hsl(var(--foreground))', marginBottom: '6px' }}>
                                            ✍️ Записать знание или установку напрямую в память агента (+15 XP):
                                        </label>
                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                            <select 
                                                value={newMemoryType} 
                                                onChange={(e) => setNewMemoryType(e.target.value)}
                                                style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid hsl(var(--border))', fontSize: '13px', background: 'hsl(var(--card))' }}
                                            >
                                                <option value="creator_preference">💡 Предпочтение Директора</option>
                                                <option value="rule">⚖️ Обязательное правило</option>
                                                <option value="fact">📌 Важный факт</option>
                                                <option value="style_note">🎨 Стиль и оформление</option>
                                            </select>
                                            <input 
                                                type="text" 
                                                value={newMemoryText} 
                                                onChange={(e) => setNewMemoryText(e.target.value)}
                                                placeholder="Например: Любит когда отчеты отправляются кратким списком..."
                                                style={{ flex: 1, minWidth: '220px', padding: '8px 12px', borderRadius: '8px', border: '1px solid hsl(var(--border))', fontSize: '13px' }}
                                            />
                                            <button 
                                                type="submit" 
                                                disabled={isAddingMemory || !newMemoryText.trim()}
                                                style={{ padding: '8px 18px', borderRadius: '8px', background: '#0f172a', color: '#fff', border: 'none', fontWeight: 600, fontSize: '13px', cursor: 'pointer' }}
                                            >
                                                {isAddingMemory ? "Запоминаю..." : "Запомнить"}
                                            </button>
                                        </div>
                                    </form>

                                    {/* Memories List */}
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                        {agentMemories.length === 0 ? (
                                            <div style={{ textAlign: 'center', padding: '40px', color: 'var(--ais-muted-ink)', background: 'hsl(var(--background))', borderRadius: '12px' }}>
                                                У агента пока нет сохраненных воспоминаний. Общайтесь в чате или добавьте знание выше.
                                            </div>
                                        ) : (
                                            agentMemories.map(mem => (
                                                <div key={mem.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', padding: '12px 14px', borderRadius: '10px', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
                                                    <div style={{ flex: 1, paddingRight: '12px' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                                            <span style={{ fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '6px', background: mem.memory_type === 'rule' ? '#fee2e2' : mem.memory_type === 'creator_preference' ? '#fef3c7' : '#e0f2fe', color: mem.memory_type === 'rule' ? '#991b1b' : mem.memory_type === 'creator_preference' ? '#92400e' : '#075985', textTransform: 'uppercase' }}>
                                                                {mem.memory_type.replace('_', ' ')}
                                                            </span>
                                                            <span style={{ fontSize: '11px', color: 'var(--ais-muted-ink)' }}>
                                                                Важность: {mem.importance || 5}/10 • Использовано: {mem.uses_count || 0} раз
                                                            </span>
                                                        </div>
                                                        <p style={{ margin: 0, fontSize: '14px', color: 'hsl(var(--foreground))', lineHeight: 1.45 }}>{mem.content}</p>
                                                    </div>
                                                    <button 
                                                        type="button" 
                                                        onClick={() => handleDeleteMemoryItem(mem.id)}
                                                        style={{ background: 'transparent', border: 'none', color: 'var(--ais-muted-ink)', cursor: 'pointer', padding: '4px' }}
                                                        title="Забыть это воспоминание"
                                                    >
                                                        <Trash2 size={15} />
                                                    </button>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </div>
                            )}

                            {profileTab === 'skills' && (
                                <div style={{ padding: '1.25rem', maxWidth: '850px' }}>
                                    <div style={{ marginBottom: '1.5rem' }}>
                                        <h3 style={{ margin: 0, fontSize: '18px', fontWeight: 600, color: 'hsl(var(--foreground))' }}>⚡ Дерево навыков и развитие: {currentAgent.name}</h3>
                                        <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: 'var(--ais-muted-ink)' }}>
                                            Навыки растут автоматически по мере диалогов и выполнения задач (Continuous Learning Loop).
                                        </p>
                                    </div>

                                    {/* Level & XP Overview Card */}
                                    <div style={{ background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)', borderRadius: '14px', padding: '18px 22px', color: '#fff', marginBottom: '1.5rem', boxShadow: '0 4px 12px rgba(15,23,42,0.15)' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                                            <div>
                                                <span style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#94a3b8', fontWeight: 700 }}>Текущий статус</span>
                                                <div style={{ fontSize: '20px', fontWeight: 700, marginTop: '2px', color: '#f8fafc' }}>
                                                    {currentAgent.name} • Уровень {Math.floor((currentAgent.compute_score || 0) / 300) + 1}
                                                </div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                                <div style={{ fontSize: '24px', fontWeight: 800, color: '#fbbf24' }}>
                                                    {currentAgent.compute_score || 0} XP
                                                </div>
                                                <div style={{ fontSize: '12px', color: '#94a3b8' }}>Суммарный опыт агента</div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Skills Grid */}
                                    <h4 style={{ fontSize: '14px', fontWeight: 700, color: 'var(--ais-muted-ink)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '12px' }}>
                                        Активные компетенции
                                    </h4>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '14px' }}>
                                        {agentSkills.map(skill => {
                                            const progress = Math.min(100, Math.round(((skill.current_xp || 0) / (skill.next_level_xp || 100)) * 100));
                                            return (
                                                <div key={skill.id} style={{ background: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: '12px', padding: '16px', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                        <span style={{ fontWeight: 700, fontSize: '15px', color: 'hsl(var(--foreground))' }}>{skill.name}</span>
                                                        <span style={{ background: '#ecfdf5', color: '#059669', border: '1px solid #a7f3d0', fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '12px' }}>
                                                            Ур. {skill.level}
                                                        </span>
                                                    </div>
                                                    <p style={{ fontSize: '12px', color: 'var(--ais-muted-ink)', margin: '0 0 12px 0', minHeight: '34px', lineHeight: 1.4 }}>
                                                        {skill.description || 'Профессиональный навык агента.'}
                                                    </p>
                                                    <div>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: 'var(--ais-muted-ink)', marginBottom: '4px' }}>
                                                            <span>Прогресс уровня</span>
                                                            <span style={{ fontWeight: 600, color: 'var(--ais-muted-ink)' }}>{skill.current_xp || 0} / {skill.next_level_xp || 100} XP ({progress}%)</span>
                                                        </div>
                                                        <div style={{ height: '6px', width: '100%', background: 'hsl(var(--muted))', borderRadius: '4px', overflow: 'hidden' }}>
                                                            <div style={{ height: '100%', width: `${progress}%`, background: '#3b82f6', borderRadius: '4px', transition: 'width 0.3s ease' }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {profileTab === 'photos' && (
                                <div style={{ padding: '1rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '1rem', flexWrap: 'wrap' }}>
                                        <h3 style={{ margin: 0 }}>📷 Галерея фото: {currentAgent.name}</h3>
                                        <span style={{ color: '#888', fontSize: '13px' }}>{photoLibrary.length} фото</span>
                                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', flexWrap: 'wrap', alignItems: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => handleRequestSelfie("в офисе")}
                                                disabled={dmLoading}
                                                style={{ fontSize: '11px', padding: '4px 12px', borderRadius: '12px', border: '1px solid #C8A653', background: '#2a2415', color: '#f4d58d', cursor: 'pointer', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                                            >
                                                📸 + Новое фото
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => loadPhotoLibrary('agent')}
                                                style={{ fontSize: '11px', padding: '4px 10px', borderRadius: '12px', border: '1px solid #444', background: photoFilter === 'agent' ? '#C8A653' : 'transparent', color: photoFilter === 'agent' ? '#111' : '#aaa', cursor: 'pointer', fontWeight: photoFilter === 'agent' ? 600 : 400 }}
                                            >
                                                Фото {currentAgent.name}
                                            </button>
                                            {['all', 'katifi', 'julifi'].map(f => (
                                                <button key={f} type="button" onClick={() => loadPhotoLibrary(f)}
                                                    style={{ fontSize: '11px', padding: '4px 10px', borderRadius: '12px', border: '1px solid #444', background: photoFilter === f ? '#6c63ff' : 'transparent', color: photoFilter === f ? '#fff' : '#aaa', cursor: 'pointer' }}>
                                                    {f === 'all' ? 'Все фото' : f.charAt(0).toUpperCase() + f.slice(1)}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    {photoLoading && <div style={{ color: '#888', textAlign: 'center', padding: '2rem' }}>Загрузка галереи...</div>}
                                    {!photoLoading && photoLibrary.length === 0 && (
                                        <div style={{ color: '#888', textAlign: 'center', padding: '2.5rem', background: 'rgba(255,255,255,0.02)', borderRadius: '12px', border: '1px dashed #444' }}>
                                            <p style={{ margin: '0 0 12px 0' }}>У {currentAgent.name} пока нет сохраненных фото в галерее.</p>
                                            <button
                                                type="button"
                                                onClick={() => handleRequestSelfie("в офисе")}
                                                disabled={dmLoading}
                                                style={{ fontSize: '13px', padding: '6px 16px', borderRadius: '8px', border: '1px solid #C8A653', background: '#2a2415', color: '#f4d58d', cursor: 'pointer', fontWeight: 600 }}
                                            >
                                                📸 Сделать первое фото
                                            </button>
                                        </div>
                                    )}
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '14px' }}>
                                        {photoLibrary.map(photo => (
                                            <div key={photo.id} style={{ borderRadius: '8px', overflow: 'hidden', background: '#181b17', border: '1px solid rgba(255,255,255,0.08)' }}>
                                                <ImageBubble src={photo.url} alt={photo.prompt || photo.tags || photo.persona} onSetAvatar={handleSetAvatar} onDeletePhoto={() => handleDeleteGalleryPhoto(photo)} />
                                                <div style={{ padding: '6px 8px', fontSize: '11px', color: '#888', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div style={{ overflow: 'hidden' }}>
                                                        <div style={{ fontWeight: 600, color: '#aaa', textTransform: 'capitalize' }}>{photo.persona || currentAgent.name}</div>
                                                        {photo.prompt && <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '10px' }} title={photo.prompt}>{photo.prompt}</div>}
                                                        <div style={{ marginTop: '2px', fontSize: '10px', color: '#666' }}>{photo.created_at ? new Date(photo.created_at).toLocaleDateString() : ''}</div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteGalleryPhoto(photo)}
                                                        style={{ background: 'transparent', border: 'none', color: '#f87171', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', flexShrink: 0 }}
                                                        title="Удалить фото из галереи"
                                                    >
                                                        <Trash2 size={13} />
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                
                {activeView === 'tasks' && (
                    <div className="task-board-view">
                         <div className="task-header">
                            <h2>AI Swarm Kanban</h2>
                            <button className="btn-primary" onClick={()=>setNewTaskModalOpen(true)}>+ Post Job</button>
                        </div>
                        <div className="kanban-grid">
                            <div className="kanban-col open">
                                <h3>Open Jobs ({taskBoard.filter(t=>t.status==='Open').length})</h3>
                                {taskBoard.filter(t=>t.status==='Open').map(t=>(
                                    <div className="task-card" key={t.id}>
                                        <h4>{t.title}</h4>
                                        <p>{t.description}</p>
                                    </div>
                                ))}
                            </div>
                            <div className="kanban-col in-progress">
                                <h3>In Progress ({taskBoard.filter(t=>t.status==='In Progress').length})</h3>
                                {taskBoard.filter(t=>t.status==='In Progress').map(t=>(
                                    <div className="task-card" key={t.id}>
                                        <h4>{t.title}</h4>
                                        <p>{t.description}</p>
                                        <span className="assignee">Assigned to: {t.assigned_agent_name}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="kanban-col done">
                                <h3>Completed ({taskBoard.filter(t=>t.status==='Completed').length})</h3>
                                {taskBoard.filter(t=>t.status==='Completed').map(t=>(
                                    <div className="task-card" key={t.id}>
                                        <h4 style={{textDecoration:'line-through'}}>{t.title}</h4>
                                        <span className="assignee" style={{color:'#10b981'}}>Resolved by: {t.assigned_agent_name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {newTaskModalOpen && (
                 <div className="modal-backdrop" onClick={() => setNewTaskModalOpen(false)}>
                     <div className="modal-content" onClick={e => e.stopPropagation()}>
                         <h2>Post AI Job to Swarm</h2>
                         <input type="text" placeholder="Job Title" value={newTaskTitle} onChange={e=>setNewTaskTitle(e.target.value)} />
                         <textarea placeholder="Instruction Description for Agents" value={newTaskDesc} onChange={e=>setNewTaskDesc(e.target.value)} rows={6}></textarea>
                         <button className="btn-primary" style={{marginTop:'1.5rem', width:'100%'}} onClick={async () => {
                             if(!newTaskTitle || !newTaskDesc) return;
                             await apiService.createTaskBoardJob({ title: newTaskTitle, description: newTaskDesc });
                             const updatedTasks = await apiService.getTaskBoard();
                             setTaskBoard(updatedTasks);
                             setNewTaskModalOpen(false);
                         }}>Queue Job</button>
                     </div>
                 </div>
             )}
        </div>
    );
};

const BotsIcon = () => (
    <div style={{background: '#e0e7ff', padding: '0.75rem', borderRadius: '12px'}}>
        <Activity size={24} color="#4f46e5" />
    </div>
);

export default AiStaffPage;
